import React from 'react';
import { cn } from '../../../lib/utils';
import { SectionContainerProps } from './types';

export const SectionContainer: React.FC<SectionContainerProps> = ({
  children,
  className,
  width = 'default'
}) => {
  const widthStyles = {
    default: 'max-w-7xl',
    narrow: 'max-w-3xl',
    wide: 'max-w-screen-2xl',
    full: 'w-full'
  };

  return (
    <div className={cn(
      'mx-auto px-4 sm:px-6 lg:px-8',
      widthStyles[width],
      className
    )}>
      {children}
    </div>
  );
};